<template>
	<div>
		<h5>EmergencyPreplan</h5>
	</div>
</template>

<script>
	export default {
		name: "EmergencyPreplan",
	};
</script>

<style scoped></style>
